import type { FieldsProps } from './Fields/types';

const maxDate = new Date().toISOString().slice(0, 10);
const minDate = `${+maxDate.slice(0, 4) - 100}${maxDate.slice(4)}`;

export default [
  [
    {
      name: 'firstName',
      placeholder: '',
      required: true,
      width: 100
    },
    {
      name: 'lastName',
      placeholder: '',
      required: true,
      width: 100
    },
    {
      pattern: /^(\+31[1-9]{9}$)|^([0-9]{10}$)/,
      name: 'phoneNumber',
      placeholder: '',
      required: true,
      type: 'tel',
      width: 100
    },
    {
      name: 'dateBirth',
      required: true,
      type: 'date',
      min: minDate,
      max: maxDate,
      width: 100
    },
    {
      placeholder: 'Size',
      required: true,
      type: 'select',
      search: true,
      name: 'size',
      width: 100,
      options: [
        {
          name: 'XXS',
          value: 'xxs'
        },
        {
          name: 'XS',
          value: 'xs'
        },
        {
          name: 'S',
          value: 's'
        },
        {
          name: 'M',
          value: 'm'
        },
        {
          name: 'L',
          value: 'l'
        },
        {
          name: 'XL',
          value: 'xl'
        },
        {
          name: 'XXL',
          value: 'xxL'
        }
      ]
    },
    {
      placeholder: 'Your message...',
      name: 'textArea',
      required: false,
      maxLength: 250,
      type: 'area',
      width: 100,
      rows: 20
    }
  ],
  [
    {
      pattern: /^[0-9]{4}\s?[a-zA-Z]{2}$/,
      name: 'postalCode',
      placeholder: '',
      required: true,
      width: 100
    },
    {
      pattern: /^\d+$/,
      name: 'houseNumber',
      placeholder: '',
      required: true,
      width: 48
    },
    {
      pattern: /^[a-zA-Z0-9]{1,5}$/,
      placeholder: '',
      name: 'suffix',
      width: 48
    },
    {
      pattern: /^[^-\s][\w.,\s\\'-]+$/,
      name: 'streetName',
      placeholder: '',
      required: true,
      width: 100
    },
    {
      pattern: /^[^-\s][\w.,\s\\'-]+$/,
      placeholder: '',
      required: true,
      name: 'venue',
      width: 100
    }
  ]
] as FieldsProps;
